import React, { useState,useRef,useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import LoaderOverlay from '../common/loader.component';
import DataService from '../../services/data.service';
import { Link, useNavigate} from 'react-router-dom';
import { getSquareErrorMessage } from './errormessage';
import { format } from 'date-fns';


function Payment(props) {
  console.log(props)
  const paymentsRef = useRef(null);
  const cardRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
    const [hasError, setHasError] = useState(false); // 🔴 TRACK API ERROR

const [message,setMessage] = useState('');
  useEffect(() => {
    async function initSquare() {
      if (!window.Square) return;
        setLoading(true);
      try {
      const payments = window.Square.payments('sandbox-sq0idb-NYDs_C3-HU_DAJHd7gzjKw', 'LXV697RGVZSVP');
      paymentsRef.current = payments;

      const card = await payments.card();
      await card.attach('#card-container');
      cardRef.current = card;
    } catch (error) {
            setLoading(false); // Stop loader

      console.error('Error initializing Square:', error);
    }

    setLoading(false); // Stop loader
  }
   if (!cardRef.current) {
      initSquare();
      cardRef.current = true;
    }
  }, []);
  

  const handlePayment = async (method) => {
    setMessage('');
    try {
        const formData = props.appointmentData;
     
    
      if (method=='Card') {
          const result = await cardRef.current.tokenize();
      if(result.status === 'OK') {
        
           const requestPayload = {
               customer: {
                 name: formData.name,
                 email: formData.email,
                 phone: formData.phone,
               },
               appointment: {
                 date: format(formData.date, 'yyyy-MM-dd'),
                 time: formData.time,
                 total: props.totalPrice,
                 services: props.selectedServices.map(s => ({
                   id: s.id,
                   name: s.name,
                   price: s.price,
                   service_duration: s.service_duraion
                 })),
                 method:'Card',
                 allergies:formData.allergies,
                 allergyDetails: formData.allergyDetails,
                 retinolUse: formData.retinolUse,
                 physicianCondition: formData.physicianCondition,
                 physicianDetails: formData.physicianDetails,
                 pregnancy: formData.pregnancy,
                 nonce:result.token
               }
             };
       
                setLoading(true);
           DataService.bookAppointment(requestPayload)
             .then((response) => {
              navigate('/thank-you');
             })
             .catch((error) => {
               try {
                                setHasError(true); // 🔴 MARK ERROR

                 const message = getSquareErrorMessage(error.response.data.error_code)
                 setMessage(message)
                 //toast.error(message)
               }catch (e) {
                                setHasError(true); // 🔴 MARK ERROR

                 setMessage('Internal Server Error.')
                   // toast.error('Internal Server Error.')
               }
            
             })
             .finally(() => setLoading(false));
      }
     
       
   
      } else if(method=='Manual'){
        const requestPayload = {
               customer: {
                 name: formData.name,
                 email: formData.email,
                 phone: formData.phone,
               },
               appointment: {
                 date: formData.date,
                 time: formData.time,
                 total: props.totalPrice,
                 services: props.selectedServices.map(s => ({
                   id: s.id,
                   name: s.name,
                   price: s.price,
                    service_duration: s.service_duraion,
                    category: s.category
                 })),
                 method:'Manual',
                 allergies:formData.allergies,
                 allergyDetails: formData.allergyDetails,
                 retinolUse: formData.retinolUse,
                 physicianCondition: formData.physicianCondition,
                 physicianDetails: formData.physicianDetails,
                 pregnancy: formData.pregnancy,
               }
             };
             
       
                setLoading(true);
           DataService.bookAppointment(requestPayload)
             .then((response) => {
              navigate('/thank-you');
             })
             .catch((error) => {
               try {
                                setHasError(true); // 🔴 MARK ERROR

               //  const message = getSquareErrorMessage(error.response.data.error_code)
                 setMessage('This time slot was just booked. Please select another time.')
                 //toast.error(message)
               }catch (e) {
                                setHasError(true); // 🔴 MARK ERROR

                 setMessage('This time slot was just booked. Please select another time.')
                   // toast.error('Internal Server Error.')
               }
            
             })
             .finally(() => setLoading(false));
      }
      
      else {
       // toast.error('Internal Server Error.')
        setLoading(false);
      }
    } catch (error) {
      console.log(error)
      toast.error('Internal Server Error.')
    
    }
  };
   const handleModalClose = () => {
    props.onCloseWithData({ hasError }); // SEND ERROR FLAG TO PARENT
  };

  return (
     <>
      <LoaderOverlay loading={loading} />
      <Modal show={props.show} onHide={props.handleClose} keyboard={false}  backdrop="static" centered>
        <Modal.Header>
          <Modal.Title>Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
    <div>
    {message && (
       <div style={{
      display: 'flex',
      alignItems: 'center',
      color: 'white',
      backgroundColor: '#de2525',
      padding: '10px',
      border: '1.5px solid #f44336',
      borderRadius: '8px',
      boxShadow: '0 2px 6px rgba(244, 67, 54, 0.3)',
      fontWeight: '400',
      fontFamily: "'Open Sans', Arial, sans-serif",
      fontSize: '14px',
      margin: '5px 10px 15px 0',
      textAlign: 'left',
      gap: '12px',
    }}>
        <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    width="24"
    fill="white"
    viewBox="0 0 24 24"
  >
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
  </svg>
          {message}
        </div>
      )}

        <h5 class="pay-with-card">Pay with Card</h5>
       
        <div id="card-container" style={{  }}></div>
          <button
      onClick={() => handlePayment('Card')}
      className="btn btn-primary p-2 btn-pynow"
      disabled={props.paymentButton.is_enabled}
      style={{
    marginTop: '12px',
    cursor: props.paymentButton?.is_enabled ? 'not-allowed' : 'pointer',
  }}
    >
      Pay Now
    </button>
      
          <p style={{marginTop:'12px', marginBottom:'0px'}}>OR</p>
        <button onClick={() => handlePayment('Manual')}  disabled={props.payLaterButton.is_enabled} class="btn btn-primary p-2 btn-pynow" style={{
    marginTop: '12px',
    cursor: props.payLaterButton?.is_enabled ? 'not-allowed' : 'pointer',
  }}>Book & Pay Later</button>
       
        
        <img src="images/payCard-old.png" className="cardImg" alt="Accepted Payment Cards"></img>
      </div>




</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          {/* <Button variant="primary" onClick={() => alert('Saved!')}>
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Payment;